/*
###################################################################
Fitinsur Open Insurance - Copyright 2019-2023 - All Rights Reserved
###################################################################
*/

/* eslint-disable react-hooks/rules-of-hooks */
import React, { useState, useEffect, useContext, useRef } from 'react';
import { Form, Formik } from 'formik';
import { useHistory } from 'react-router-dom';
import { FitinsurAPI, MessageCenter } from 'utils';
import Layout from 'components/Layout';
import StepNavigation from 'components/StepNavigation';
import BrokingSummary from 'components/BrokingSummary';
import { Button, ButtonContainer } from "@fitinsur/components";
import ContentCard from 'components/ContentCard';
import ModalConfirmation from 'components/ModalConfirmation';
import { GridColumnTitle } from "components/Form";
import {
    ButtonContent,
    Table,
    TableHead,
    TableRow,
    TableHeader,
    TableBody,
    TableCollum,
    LabelEdit
} from './styles';
import { Icon, LostCancelButton } from 'components/index';
import HasPermission from 'components/HasPermission/index';
import { GlobalAuthContext, GlobalLoaderContext } from 'store/context';
import { LoaderContext } from '@fitinsur/contexts';
import { useGenerateOrderToBind } from 'services/QuoteService';
import { useGetOperation, useUpdateOperationSync } from 'services/OperationService';
import { useDeleteVoidStamp, useReSendStamp } from 'services/StampService';
import { isEmpty, cloneDeep, set } from 'lodash';
import { useGetQuestionnaireAnswer, useSaveQuestionnaireAnswer } from 'services/QuestionnaireAnswerService';
import { FormSectionGlobal as FormSection } from '@fitinsur/components';
import { useGetDocuments, useUpdateDocument } from 'services/DocumentsService';


const statusList = {
    sent: 'Envelope Solicitado',
    signed: 'Envelope assinado',
    voided: 'Envelope Cancelado',
    manual: 'Assinado Manualmente',
}

const SECTIONS = {
    CCG_SIGNATURE: { name: 'CCG_SIGNATURE', isMultiple: false, isRisk: false },
};

export default function StampStatusList({ permissions, match }) {
    const authContext = useContext(GlobalAuthContext);
    const { updateIsLoadingStatus } = useContext(LoaderContext);

    const history = useHistory();
    const fitinsur = new FitinsurAPI();
    const mc = new MessageCenter();
    const formikRef = useRef();
    const getQuestionnaire = useRef(false);

    const [operation, setOperation] = useState({});
    const [document, setDocument] = useState({});
    const [stampDocument, setStampDocument] = useState({});
    const [signers, setSigners] = useState([]);
    const [certifiedDeliveries, setCertifiedDeliveries] = useState([]);
    const [allParty, setAllParty] = useState([]);
    const [summary, setSummary] = useState({});
    const [modalReSendStamp, setModalReSendStamp] = useState(false);
    const [modalCancelStamp, setModalCancelStamp] = useState(false);
    const [questionnaire, setQuestionnaire] = useState([]);
    const [signerSelectedReSend, setSignerSelectedReSend] = useState({});
    const [createEnquiry, setCreateEnquiry] = useState(false);
    const [isBound, setIsBound] = useState(false);
    const [filter, setFilter] = useState(
        {
            key: null,
            direction: null,
        }
    );
    const [isFullSigned, setIsFullSigned] = useState(false);
    const columns = [
        {
            title: "PARTES",
            value: "partes"
        },
        {
            title: "TIPO",
            value: "tipo"
        },
        {
            title: "E-MAIL",
            value: "email",
        },
        {
            title: "SITUAÇÃO",
            value: "situacao"
        },
        {
            title: "ASSINATURA SOLICITADA",
            value: "assinaturaSolicitada"
        },
        {
            title: "DATA ASSINATURA",
            value: "dataAssinatura"
        },
        {
            title: "AÇÕES",
            value: ""
        },
    ];

    const {
        data: useGenerateOrderToBindData,
        loading: useGenerateOrderToBindLoading,
        error: useGenerateOrderToBindError,
        status: useGenerateOrderToBindStatus,
        request: useGenerateOrderToBindRequest,
    } = useGenerateOrderToBind(match?.params?.idOperation);

    const {
        data: useGetOperationData,
        loading: useGetOperationLoading,
        error: useGetOperationError,
        status: useGetOperationStatus,
        request: useGetOperationRequest
    } = useGetOperation(match.params?.idOperation);

    const {
        loading: useUpdateOperationLoading,
        request: useUpdateOperationRequest
    } = useUpdateOperationSync(match.params?.idOperation);

    const {
        data: useGetQuestionnairesAnswersData,
        loading: useGetQuestionnairesAnswersLoading,
        error: useGetQuestionnairesAnswersError,
        status: useGetQuestionnairesAnswersStatus,
        request: useGetQuestionnairesAnswersRequest,
    } = useGetQuestionnaireAnswer(match.params?.idOperation);

    const {
        data: useSaveQuestionnaireAnswerData,
        loading: useSaveQuestionnaireAnswerLoading,
        error: useSaveQuestionnaireAnswerError,
        status: useSaveQuestionnaireAnswerStatus,
        request: useSaveQuestionnaireAnswerRequest,
    } = useSaveQuestionnaireAnswer(match?.params?.idOperation);

    const {
        data: useGetDocumentsData,
        loading: useGetDocumentsLoading,
        error: useGetDocumentsError,
        status: useGetDocumentsStatus,
        request: useGetDocumentsRequest
    } = useGetDocuments(match.params?.idOperation);

    const {
        data: useUpdateDocumentData,
        loading: useUpdateDocumentLoading,
        error: useUpdateDocumentError,
        status: useUpdateDocumentStatus,
        request: useUpdateDocumentRequest
    } = useUpdateDocument(match.params?.idOperation, document?.idDocument);

    const {
        data: useDeleteVoidStampData,
        loading: useDeleteVoidStampLoading,
        error: useDeleteVoidStampError,
        status: useDeleteVoidStampStatus,
        request: useDeleteVoidStampRequest
    } = useDeleteVoidStamp(match.params?.idOperation);

    const {
        data: useReSendStampData,
        loading: useReSendStampLoading,
        error: useReSendStampError,
        status: useReSendStampStatus,
        request: useReSendStampRequest
    } = useReSendStamp(match.params?.idOperation);

    useEffect(() => {
        useGetOperationRequest(null, { loadOperationPersonRoles: true });
        getWebhookFallback()
    }, [])

    useEffect(() => {
        if (getQuestionnaire.current) return;
        if (isEmpty(permissions)) return;

        useGetOperationRequest(null, { loadOperationPersonRoles: true });
        getWebhookFallback()
        getQuestionnaire.current = true
    }, [permissions]);

    useEffect(() => {
        updateIsLoadingStatus(
            useGenerateOrderToBindLoading ||
            useGetOperationLoading ||
            useGetDocumentsLoading ||
            useReSendStampLoading ||
            useDeleteVoidStampLoading ||
            useUpdateOperationLoading ||
            useGetQuestionnairesAnswersLoading ||
            useSaveQuestionnaireAnswerLoading ||
            useUpdateDocumentLoading
        );
    }, [
        useGenerateOrderToBindLoading,
        useGetOperationLoading,
        useGetDocumentsLoading,
        useReSendStampLoading,
        useDeleteVoidStampLoading,
        useUpdateOperationLoading,
        useGetQuestionnairesAnswersLoading,
        useSaveQuestionnaireAnswerLoading,
        useUpdateDocumentLoading
    ]);

    useEffect(() => {
        if (useGetOperationStatus === 200) {
            let operationData;
            if (useGetOperationData.status === 200) {
                operationData = useGetOperationData.data?.value;
                setOperation(operationData);
            }
            useGetDocumentsRequest(null);
            useGetQuestionnairesAnswersRequest(null);
        }
    }, [useGetOperationStatus])

    useEffect(() => {
        if (!useGetDocumentsStatus) return;
        if (useGetDocumentsStatus === 200) {
            const stampDocument = useGetDocumentsData.value?.find(v => v.idDomain === 366);
            if (stampDocument) {
                setStampDocument(stampDocument);
                setSigners(stampDocument?.documentMetadata.signers || [])
                setAllParty([
                    ...(stampDocument?.documentMetadata.signers || []),
                    ...(stampDocument?.documentMetadata.certifiedDeliveries || [])
                ]);
            }
            const ccgDocument = useGetDocumentsData.value?.find(v => v.idDomain === 689);
            if (ccgDocument) {
                setDocument(ccgDocument);
                setIsBound([424, 422, 133, 158, 187, 263, 104, 99, 159, 140, 177, 188, 198, 176, 403].includes(ccgDocument.idDomainStatus))
            }
        }
    }, [useGetDocumentsStatus])

    // useEffect(() => {
    //     if (!useGenerateOrderToBindStatus) return;
    //     if (useGenerateOrderToBindStatus === 200) {
    //         history.push(`/send-bind-request-contacts/${match.params.idOperation}`)
    //     }
    // }, [useGenerateOrderToBindStatus]);

    useEffect(() => {
        if (useGetQuestionnairesAnswersStatus === 200) {
            let questionnaire = [];
            questionnaire = [
                ...useGetQuestionnairesAnswersData?.value.persons,
                ...useGetQuestionnairesAnswersData?.value.operations,
                ...useGetQuestionnairesAnswersData?.value.payments,
                ...useGetQuestionnairesAnswersData?.value.risks
            ];
            setQuestionnaire(questionnaire);
        }
    }, [useGetQuestionnairesAnswersStatus]);

    useEffect(() => {
        if (useDeleteVoidStampStatus === 200) {
            history.push('/credit-analysis/list');
        }

        if (useDeleteVoidStampStatus === 400)
            mc.error('Erro ao cancelar envio de assinaturas');
    }, [useDeleteVoidStampStatus]);

    useEffect(() => {
        if (!isEmpty(signers)) setIsFullSigned(checkTotalSigners());
    }, [signers])

    // useEffect(() => {
    //     if (isFullSigned) useUpdateOperationRequest({ idDomainStatus: 427 });
    // }, [isFullSigned])

    useEffect(() => {
        if (useReSendStampStatus === 200) {
            useGetOperationRequest(null, { loadOperationPersonRoles: true });
            useGetDocumentsRequest(null, { idDomain: 366 });
            getWebhookFallback()
        }
    }, [useReSendStampStatus]);

    useEffect(() => {
        permissions?.CREATE_ENQUIRY ? setCreateEnquiry(true) : setCreateEnquiry(false);
    }, [permissions]);

    function handleSortList(key) {
        let direction = 'asc';
        if (filter.key === key && filter.direction === 'asc') {
            direction = 'desc';
        }
        setFilter({ key: key, direction: direction });
    }

    function getWebhookFallback() {
        fitinsur.setAuthToken(authContext.token);
        fitinsur.requestGetPolicyStampStatus(match.params.idOperation)
            .then(x => x.json())
            .then(res => true).catch(e => console.log(e))
    }

    const checkTotalSigners = () => {
        return signers.length === signers.filter(sgn => sgn.signedAt).length;
    }

    const handleReSendStamp = (selectedSigner) => {
        if (selectedSigner.status !== 'sent')
            return;

        const signer = {
            recipientId: selectedSigner.recipientId,
            realEmailData: selectedSigner.realEmailData,
            name: selectedSigner.name,
            email: selectedSigner.email,
            idPerson: selectedSigner.idPerson
        };

        useReSendStampRequest({ signer })
    }

    const handleRegenerateCCG = async () => {
        return history.push(`/credit-analysis/ccg-edit/57/${match.params?.idOperation}`);
    }

    const handleFormalizeCCG = async () => {
        handleSaveQuestionnaireAnswer(match.params.idOperation);

        const updatedQuestionnaire = handleSaveQuestionnaireAnswer(match.params.idOperation, true)
        const qstPendingDocuments = updatedQuestionnaire.find(qst => qst.idQuestion === 1802);
        if (qstPendingDocuments?.idAnswerOption === 7386) {
            await useUpdateDocumentRequest({ idDomainStatus: 423 });
            mc.success('Este CCG foi formalizado parcialmente');
        } else if (!qstPendingDocuments?.idAnswerOption || qstPendingDocuments?.idAnswerOption === 7387) {
            await useUpdateDocumentRequest({ idDomainStatus: 422 });
            mc.success('Este CCG foi formalizado');
        }
        history.push('/credit-analysis')
    }

    const handleSaveQuestionnaireAnswer = (idOperation, onlyQuestions, formattedGroups) => {
        let questionnaireAnswers = cloneDeep(questionnaire);
        for (const [key, section] of Object.entries(SECTIONS)) {
            if (section.isMultiple) {
                let multipleFields = []
                switch (section.name) {
                    default:
                        multipleFields = [];
                        break;
                }

                // QUEBRANDO O CODIGO
                multipleFields.map(group => {
                    if (group?.length) {
                        const rootQuestion = group.find(question => !question.idQuestionRoot);
                        const childrenQuestions = group.filter(question => question.idQuestionRoot);
                        rootQuestion.childrenQuestions = childrenQuestions;
                        if (!onlyQuestions || formattedGroups) {
                            questionnaireAnswers = [...questionnaireAnswers, rootQuestion];
                        } else {
                            questionnaireAnswers = [...questionnaireAnswers, ...group];
                        }
                    }
                })
            }
        }

        let childrenQuestionIds = [];
        for (const question of questionnaireAnswers) {
            if (question) {
                if (
                    (
                        question.idDomainQuestion === 270 ||
                        question.idDomainQuestion === 271 ||
                        (question.idDomainQuestion === 44 && typeof question.answer === 'object')
                    ) && question.answer
                ) {
                    try {
                        question.answer = JSON.stringify(question.answer)
                    } catch (e) {
                    }
                }

                if (SECTIONS[question.behaviorObject?.sectionName] && SECTIONS[question.behaviorObject?.sectionName].isMultiple) {
                    if (question?.childrenQuestions?.length) {
                        const idQuestions = question.childrenQuestions.map(question => question.idQuestion);
                        childrenQuestionIds = [...childrenQuestionIds, ...idQuestions];
                    }
                } else {
                    question.childrenQuestions = [];
                }
                // if (
                //     currentModality &&
                //     question.productPlans?.length &&
                //     !question.productPlans.includes(currentModality) &&
                //     (question?.answer != null || question?.idAnswerOption)
                // ) {
                //     question.answer = null;
                //     question.idAnswerOption = null;
                // }
            }
        }

        questionnaireAnswers = questionnaireAnswers
            .filter(v => !childrenQuestionIds.includes(v.idQuestion))
            .filter(v => v.behaviorObject?.sectionName === 'CCG_SIGNATURE')

        if (onlyQuestions) return questionnaireAnswers;

        if (idOperation) useSaveQuestionnaireAnswerRequest(questionnaireAnswers);
    }

    return (
        <Layout idOperation={match?.params?.idOperation}>
            <StepNavigation stage={3} idOperation={match?.params?.idOperation} />
            <BrokingSummary idOperation={match?.params?.idOperation} permissions={permissions} />
            <ModalConfirmation
                title="Aviso importante"
                text="Tem certeza que deseja re-enviar a(s) assinatura(s)?"
                textButtonCancel="NÃO"
                textButtonConfirm="SIM"
                show={modalReSendStamp}
                onConfirm={() => {
                    handleReSendStamp(signerSelectedReSend)
                    setModalReSendStamp(false)
                }}
                onCancel={() => setModalReSendStamp(false)}
            />
            <ModalConfirmation
                title="Aviso importante"
                text="Tem certeza que deseja cancelar o envio da(s) assinaturas?"
                textButtonCancel="NÃO"
                textButtonConfirm="SIM"
                show={modalCancelStamp}
                onConfirm={() => {
                    useDeleteVoidStampRequest()
                    setModalCancelStamp(false)
                }}
                onCancel={() => setModalCancelStamp(false)}
            />
            <ContentCard title="SOLICITAÇÃO - ASSINATURA ELETRÔNICA" icon>
                <Table>
                    <TableHead>
                        <TableRow>
                            {columns.map((column, index) =>
                                <TableHeader>

                                    <GridColumnTitle style={{ textTransform: 'uppercase' }} onClick={() => handleSortList(column.value)}>
                                        {column.title}
                                    </GridColumnTitle>

                                    {filter.key === column.value && filter.direction === "asc" ?
                                        <Icon name={"arrowup"} /> :
                                        filter.key === column.value && filter.direction === "desc" ?
                                            <Icon name={"arrowdown"} /> :
                                            ''}
                                </TableHeader>)
                            }
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {allParty.map((item, index) => (
                            <TableRow key={index}>
                                <TableCollum>
                                    <LabelEdit>{item.name}</LabelEdit>
                                </TableCollum>
                                <TableCollum>
                                    <LabelEdit>{item.partyType}</LabelEdit>
                                </TableCollum>
                                <TableCollum>
                                    <LabelEdit>{item.realEmailData}</LabelEdit>
                                </TableCollum>
                                <TableCollum>
                                    <LabelEdit>{statusList[item.status]?.toUpperCase()}</LabelEdit>
                                </TableCollum>
                                <TableCollum>
                                    <LabelEdit>{item.sentAt ? `${new Date(item.sentAt).toLocaleDateString('pt-BR')} ${new Date(item.sentAt).toLocaleTimeString('pt-BR')}` : '-'}</LabelEdit>
                                </TableCollum>
                                <TableCollum>
                                    <LabelEdit>{item.signedAt ? `${new Date(item.signedAt).toLocaleDateString('pt-BR')} ${new Date(item.signedAt).toLocaleTimeString('pt-BR')}` : '-'}</LabelEdit>
                                </TableCollum>
                                <TableCollum>
                                    {
                                        item.name && stampDocument?.idDomainStatus !== 454 ?
                                            <Icon
                                                name="email"
                                                title="re-enviar"
                                                style={!item.signedAt
                                                    ? { cursor: "pointer", marginLeft: '0px' }
                                                    : { cursor: "not-allowed" }
                                                }
                                                onClick={() => {
                                                    setSignerSelectedReSend(item);
                                                    [422, 423, 424].includes(document?.idDomainStatus)
                                                        ? mc.error('O contrato já está assinado. Não é possível reenviar para assinatura.')
                                                        : setModalReSendStamp(true);
                                                }}
                                            />
                                            :
                                            <></>
                                    }
                                </TableCollum>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
                <HasPermission permission={isFullSigned}>
                    <Formik
                        innerRef={formikRef}
                        initialValues={{}}
                        validateOnChange={false}
                        validateOnBlur={false}
                        enableReinitialize={true}
                    >
                        {({ values, setFieldValue, errors, setFieldError }) => (
                            <Form style={{ marginTop: '30px' }}>
                                <FormSection
                                    setQuestionnaire={setQuestionnaire}
                                    sectionName="CCG_SIGNATURE"
                                    disableAll={isBound}
                                    idProduct={match.params.idProduct}
                                    values={values}
                                    errors={errors}
                                    setFieldValue={setFieldValue}
                                    setFieldError={setFieldError}
                                    questionnaire={questionnaire}
                                    permissions={permissions}
                                    ignoreModality
                                    onQuestionChange={(
                                        question,
                                        value,
                                        setFieldValue,
                                        questionnaireUpdated
                                    ) => {
                                        if (question.idQuestion === 1802 && value?.idAnswerOption) {
                                            const answerOption = question.answerOptions.find(v => v.idAnswerOption === value?.idAnswerOption);
                                            setQuestionnaire(questionnaire.map(qst => {
                                                if (qst.idQuestion === 1802) {
                                                    qst.answer = answerOption.dsAnswerOption;
                                                    qst.idAnswerOption = answerOption.idAnswerOption;
                                                }
                                                return qst;
                                            }))
                                        }
                                    }}
                                />
                            </Form>
                        )}
                    </Formik>
                </HasPermission>

                <ButtonContainer>
                    <Button forth onClick={() => { history.goBack() }}>&lt; Voltar</Button>
                    <ButtonContent>
                        <HasPermission permission={!isEmpty(signers) && !isFullSigned && ![421, 428].includes(stampDocument?.idDomainStatus) && permissions?.CANCEL_SEND_CREDIT_ANALYSIS}>
                            <Button
                                id="btnCancel"
                                type="button"
                                primary
                                onClick={() => setModalCancelStamp(true)}
                            >
                                CANCELAR SOLICITAÇÃO DE ASSINATURA
                            </Button>
                        </HasPermission>
                        
                        <HasPermission permission={(isFullSigned || [421, 428].includes(stampDocument?.idDomainStatus)) && permissions?.REGENERATE_CREDIT_ANALYSIS}>
                            <Button
                                id="btnRegenerateCCG"
                                type="button"
                                primary
                                onClick={() => handleRegenerateCCG()}
                            >
                                REGERAR CCG
                            </Button>
                        </HasPermission>
                        <HasPermission permission={[440, 423].includes(document?.idDomainStatus) && permissions?.FORMALIZE_CREDIT_ANALYSIS}>
                            <Button
                                id="btnCompleteCCG"
                                type="button"
                                primary
                                onClick={() => handleFormalizeCCG()}
                            >
                                FORMALIZAR CCG
                            </Button>
                        </HasPermission>
                        <HasPermission permission={createEnquiry}>
                            <Button
                                id="btnCreateQuote"
                                type="button"
                                onClick={() => history.push("/list")}
                                style={{ marginLeft: 15 }}
                                primary
                            >
                                CRIAR COTAÇÃO
                            </Button>
                        </HasPermission>
                    </ButtonContent>
                </ButtonContainer>
            </ContentCard >
        </Layout >
    )
}
